(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('NOVEDAD_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<novedad-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'permisos-categoria="' + resolve + 'permisosCategoria"' +
                'categorias="' + resolve + 'categorias"' +
                'idiomas="' + resolve + 'idiomas"' +
                '></novedad-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Novedad) {
                        return new Novedad();
                    },
                    /* @ngInject */
                    permisosCategoria: function (COMPONENTES) {
                        return COMPONENTES.novedades.categoriasAdmin;
                    },
                    /* @ngInject */
                    categorias: function (CategoriaNovedad) {
                        return CategoriaNovedad.query({sortProperty: 'nombre'}).$promise.then(function (data) {
                            return data.content;
                        });
                    },
                    /* @ngInject */
                    idiomas: function (Language) {
                        return Language.getList();
                    }
                }
            }
        });
})();
